import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/pages/Dashboard/dashboard'),
        },
        {
          path: '/core/transfers',
          name: 'transfers',
          component: () => import('@/v2/transfers/transfers'),
        },
        {
          path: '/core/transfers/:id',
          name: 'transfers',
          component: () => import('@/v2/transfers/transferDetails'),
        },
        {
          path: '/core/transfersRules',
          name: 'transfers',
          component: () => import('@/v2/transfer-rules/rules'),
        },
        {
          path: '/tickets',
          name: 'tickets',
          component: () => import('@/pages/Tickets/Tickets.vue'),
        },
        {
          path: '/ticketDetails/:id',
          name: 'ticketDetails',
          component: () => import('@/pages/Tickets/TicketsDetails.vue'),
        },
        {
          path: '/addTicket',
          name: 'addTicket',
          component: () => import('@/pages/Tickets/AddTicket.vue'),
        },
        {
          path: '/roles/:id',
          name: 'roles',
          component: () => import('@/pages/Roles/RolesDetails.vue'),
        },
        {
          path: '/addRole',
          name: 'addRole',
          component: () => import('@/pages/Roles/AddRole.vue'),
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('@/pages/Users/Users.vue'),
        },
        {
          path: '/sharing',
          name: 'sharing',
          component: () => import('@/pages/Sharing/Sharing.vue'),
        },
        {
          path: '/done-checkout',
          name: 'DoneCheckouts',
          component: () => import('@/pages/Sharing/DoneCheckouts.vue'),
        },
        {
          path: '/creditors',
          name: 'creditors',
          component: () => import('@/pages/Acc/creditors.vue'),
        },
        {
          path: '/identifier',
          name: 'Identifier',
          component: () => import('@/pages/Identifier/IdentifierList.vue'),
        },
        {
          path: '/identifier/details/:id',
          name: 'IdentifierDetails',
          component: () =>
            import(
              '@/pages/Identifier/IdentifierDetails/IdentifierDetails.vue'
            ),
        },
        {
          path: '/acc/customers',
          name: 'Customers',
          component: () => import('@/pages/Acc/Customers.vue'),
        },
        {
          path: '/acc/income',
          name: 'incomes',
          component: () => import('@/pages/Acc/incomes.vue'),
        },
        {
          path: '/TurnOver',
          name: 'TurnOver',
          component: () => import('@/pages/Acc/TurnOverList.vue'),
        },
        {
          path: '/SharingDetails/:id',
          name: 'sharingDetails',
          component: () =>
            import('@/pages/Sharing/SharingDetails/SharingDetails.vue'),
        },
        {
          path: '/addUser',
          name: 'addUser',
          component: () => import('@/pages/Users/AddUser.vue'),
        },
        {
          path: '/editUser/:id',
          name: 'editUser',
          component: () => import('@/pages/Users/EditUser.vue'),
        },
        {
          path: '/metadataGroups',
          name: 'metadataGroups',
          component: () => import('@/pages/MetaData/MetadataGroups.vue'),
        },
        {
          path: '/metadata/:id',
          name: 'metadata',
          component: () => import('@/pages/MetaData/MetadataList.vue'),
        },
        {
          path: '/addDepartment',
          name: 'addDepartment',
          component: () =>
            import('@/pages/TicketDepartments/AddDepartment.vue'),
        },
        {
          path: '/editDepartment/:id',
          name: 'editDepartment',
          component: () =>
            import('@/pages/TicketDepartments/EditDepartment.vue'),
        },
        {
          path: '/addMenu',
          name: 'addMenu',
          component: () => import('@/pages/Menu/AddMenu.vue'),
        },
        {
          path: '/editMenu/:id',
          name: 'editMenu',
          component: () => import('@/pages/Menu/EditMenu.vue'),
        },
        {
          path: '/editGateway/:id',
          name: 'editGateway',
          component: () => import('@/pages/Gateways/editGateway.vue'),
        },
        {
          path: '/viewGateway/:id',
          name: 'viewGateway',
          component: () => import('@/pages/Gateways/viewGateway.vue'),
        },
        {
          path: '/addReport',
          name: 'addReport',
          component: () => import('@/pages/Report/AddReport.vue'),
        },
        {
          path: '/editReport/:id',
          name: 'editReport',
          component: () => import('@/pages/Report/AddReport.vue'),
        },
        {
          path: '/addAccSetting',
          name: 'addAccSetting',
          component: () => import('@/pages/Acc/Setting/AccSetting.vue'),
        },
        {
          path: '/editAccSetting/:id',
          name: 'editAccSetting',
          component: () => import('@/pages/Acc/Setting/AccSetting.vue'),
        },
        {
          path: '/addAccDetail',
          name: 'addAccDetail',
          component: () => import('@/pages/Acc/Detail/AccDetail.vue'),
        },
        {
          path: '/editAccDetail/:id',
          name: 'editAccDetail',
          component: () => import('@/pages/Acc/Detail/AccDetail.vue'),
        },
        {
          path: '/Topics',
          name: 'Topics',
          component: () => import('@/pages/Acc/Topics/topicList.vue'),
        },
        {
          path: '/addTopic',
          name: 'addTopic',
          component: () => import('@/pages/Acc/Topics/AddTopic.vue'),
        },
        {
          path: '/editTopic/:id',
          name: 'editTopic',
          component: () => import('@/pages/Acc/Topics/AddTopic.vue'),
        },
        {
          path: '/Balance',
          name: 'Balance',
          component: () => import('@/pages/Acc/Docs/Balance.vue'),
        },
        {
          path: '/detaileds',
          name: 'Detaileds',
          component: () => import('@/pages/Acc/Docs/Detaileds.vue'),
        },
        {
          path: '/documents',
          name: 'Documents',
          component: () => import('@/pages/Acc/Docs/Documents.vue'),
        },
        {
          path: '/docTransactions',
          name: 'DocTransactions',
          component: () => import('@/pages/Acc/Docs/DocTransactions.vue'),
        },
        {
          path: '/newDocument',
          name: 'newDocument',
          component: () => import('@/pages/Acc/Docs/newDocument.vue'),
        },
        {
          path: '/editDocument/:id',
          name: 'editDocument',
          component: () => import('@/pages/Acc/Docs/newDocument.vue'),
        },
        {
          path: '/EditSettlement/:id',
          name: 'EditSettlement',
          component: () => import('@/pages/Acc/Settlement/Settlement.vue'),
        },
        {
          path: '/editCustomer/:id',
          name: 'editCustomer',
          component: () => import('@/pages/Customer/CustomerData.vue'),
        },
        {
          path: '/editUserConf/:id',
          name: 'editUserConf',
          component: () => import('@/pages/Customer/editUserConf.vue'),
        },
        {
          path: '/Customers',
          name: 'Customers',
          component: () => import('@/pages/Customers/Customers.vue'),
        },
        {
          path: '/clients',
          name: 'Clients',
          component: () => import('@/pages/Customer/Clients.vue'),
        },
        {
          path: '/shaparak_referral',
          name: 'Clients',
          component: () => import('@/pages/Shaparak/shaparak_referral.vue'),
        },
        {
          path: '/clientdetails/:id',
          name: 'ClientDetails',
          component: () => import('@/pages/Customer/ClientDetails.vue'),
        },
        {
          path: '/viewclientdetails/:id',
          name: 'ViewClientDetails',
          component: () => import('@/pages/Customer/ViewClientDetails.vue'),
        },
        {
          path: '/AddCustomer',
          name: 'AddCustomer',
          component: () => import('@/pages/Customers/AddCustomer.vue'),
        },
        {
          path: '/AddCustomer/:id',
          name: 'AddCustomer',
          component: () => import('@/pages/Customers/AddCustomer.vue'),
        },
        {
          path: '/CustomerDetail/:id',
          name: 'CustomerDetail',
          component: () => import('@/pages/Customers/CustomerDetail.vue'),
        },
        {
          path: '/AddEvent/:customerId',
          name: 'AddEvent',
          component: () => import('@/pages/Customers/Events/AddEvent.vue'),
        },
        {
          path: '/AddEvent/:customerId/:id',
          name: 'AddEvent',
          component: () => import('@/pages/Customers/Events/AddEvent.vue'),
        },
        {
          path: '/AddEvent',
          name: 'AddEvent',
          component: () => import('@/pages/Customers/Events/AddEvent.vue'),
        },
        {
          path: '/shaparakmerchants',
          name: 'Merchants',
          component: () => import('@/pages/Merchants/ShaparakMerchants.vue'),
        },
        {
          path: '/merchants',
          name: 'Merchants',
          component: () => import('@/pages/Merchants/Merchants.vue'),
        },
        {
          path: '/dollar-merchants',
          name: 'dollarMerchants',
          component: () => import('@/pages/Merchants/DollarMerchants.vue'),
        },
        {
          path: '/merchantsUpdate',
          name: 'MerchantsUpdate',
          component: () => import('@/pages/Merchants/MerchantsUpdate.vue'),
        },
        {
          path: 'ayandereport',
          name: 'ayandereport',
          component: () => import('@/pages/Report/ayandereport.vue'),
        },
        {
          path: '/Authentication',
          name: 'Authentication',
          component: () => import('@/pages/Users/Authentication.vue'),
        },
        {
          path: '/TransactionList',
          name: 'TransactionList',
          component: () => import('@/pages/Transaction/TransactionList.vue'),
        },
        {
          path: '/EkhtelafHesab',
          name: 'EkhtelafHesab',
          component: () => import('@/pages/Transaction/EkhtelafHesab.vue'),
        },
        {
          path: '/dollar-transaction-list',
          name: 'dollarTransactionList',
          component: () =>
            import('@/pages/Transaction/DollarTransactionList.vue'),
        },
        // {
        //   path: "/TransactionList_1",
        //   name: "TransactionList",
        //   component: () => import("@/pages/Transaction/TransactionList_1.vue"),
        // },
        {
          path: '/nationalcard',
          name: 'Nationalcard',
          component: () => import('@/pages/Users/NationalcardConfirmation.vue'),
        },
        {
          path: '/ConfirmNationalCode/:id',
          name: 'ConfirmNationalCode',
          component: () => import('@/pages/Users/ConfirmNationalCode.vue'),
        },
        {
          path: '/sheba',
          name: 'confirmAccounts',
          component: () => import('@/pages/Users/ShebaConfirmation.vue'),
        },
        {
          path: '/Exchange',
          name: 'Exchange',
          component: () => import('@/pages/Exchange/Exchange.vue'),
        },
        {
          path: '/confirmSheba/:id',
          name: 'confirmSheba',
          component: () => import('@/pages/Users/confirmSheba.vue'),
        },

        {
          path: '/rp/:id',
          name: 'Report',
          component: () => import('@/components/Reporter.vue'),
        },
        {
          path: '/gardesh',
          name: 'Gardesh',
          component: () => import('@/pages/Acc/gardesh.vue'),
        },
        {
          path: '/getinfowithiban',
          name: 'GetInfoWithIban',
          component: () => import('@/pages/Finnotech/GetInfoWithIban.vue'),
        },
        {
          path: '/convertcardtoiban',
          name: 'convertCardToIban',
          component: () => import('@/pages/Finnotech/convertCardToIban.vue'),
        },
        {
          path: '/cardinquiry',
          name: 'CardInquiry',
          component: () => import('@/pages/Finnotech/CardInquiry.vue'),
        },
        {
          path: '/getProfit',
          name: 'GetProfit',
          component: () => import('@/pages/Acc/GetProfit.vue'),
        },
        {
          path: '/getayandebestankar',
          name: 'getayandebestankar',
          component: () => import('@/pages/Acc/getayandebestankar.vue'),
        },
        {
          path: '/wallet_payment_request',
          name: 'WalletPaymentRequest',
          component: () => import('@/pages/Acc/WalletPaymentRequest.vue'),
        },
        {
          path: '/paynationalprq/:id',
          name: 'paynationalprq',
          component: () => import('@/pages/Acc/paynationalprq.vue'),
        },
        {
          path: '/activegateway',
          name: 'activeGateway',
          component: () => import('@/pages/Gateways/activeGateway.vue'),
        },
        {
          path: '/messages',
          name: 'messages',
          component: () => import('@/pages/Message/Messages.vue'),
        },
        {
          path: '/AddMessage',
          name: 'AddMessage',
          component: () => import('@/pages/Message/AddMessage.vue'),
        },
        {
          path: '/switchResult',
          name: 'switchResult',
          component: () => import('@/pages/Transaction/switchResult.vue'),
        },
        {
          path: '/AccReport',
          name: 'AccReport',
          component: () => import('@/pages/Acc/AccReport.vue'),
        },
        {
          path: '/ayanderr',
          name: 'ayanderr',
          component: () => import('@/pages/Acc/AccReport2.vue'),
        },
        {
          path: '/calcincome',
          name: 'CalcIncome',
          component: () => import('@/pages/Acc/CalcIncome.vue'),
        },
        {
          path: '/undoneRefundsCharges',
          name: 'CalcIncome',
          component: () => import('@/pages/Refund/UndoneRefundList'),
        },
        {
          path: '/undoneRefund/:id',
          name: 'undoneRefund',
          component: () => import('@/pages/Refund/undoneDetails.vue'),
        },
        {
          path: '/InterbankTransaction',
          name: 'InterbankTransaction',
          component: () => import('@/pages/Acc/InterbankTransaction.vue'),
        },
        {
          path: '/monthly-report',
          name: 'monthlyReport',
          component: () => import('@/pages/Report/MonthlyReport.vue'),
        },
        {
          path: '/accounters-report/transactions',
          name: 'AccountersReportTransactions',
          component: () =>
            import('@/pages/Acc/Accounters/TransactionsList.vue'),
        },
        {
          path: '/accounters-report/referrals',
          name: 'Referrals',
          component: () => import('@/pages/Acc/Accounters/Referrals.vue'),
        },
        {
          path: '/accounters-report/SattlementOfDate',
          name: 'AccountersReportTransactions',
          component: () =>
            import('@/pages/Acc/Accounters/SattlementOfDate.vue'),
        },
        {
          path: '/accounters-report/creditors',
          name: 'AccountersReportCreditors',
          component: () => import('@/pages/Acc/Accounters/Creditors.vue'),
        },
        {
          path: '/accounters-report/refunds',
          name: 'AccountersReportRefunds',
          component: () => import('@/pages/Acc/Accounters/Refunds.vue'),
        },
        {
          path: '/accounters-report/sharing',
          name: 'AccountersReportSharing',
          component: () => import('@/pages/Acc/Accounters/Sharing.vue'),
        },
        {
          path: '/accounters-report/bank-deposit',
          name: 'bankDeposit',
          component: () => import('@/pages/Acc/Accounters/BankDeposit.vue'),
        },
        {
          path: '/refund-transaction',
          name: 'RefundTransactionList',
          component: () => import('@/pages/Refund/RefundTransaction.vue'),
        },
        {
          path: '/goal-link-list',
          name: 'GoalLinkList',
          component: () => import('@/pages/GoalLinks/GoalLinkList.vue'),
        },
        {
          path: '/goal-link-transaction/:id',
          name: 'GoalLinkTransaction',
          component: () => import('@/pages/GoalLinks/GoalLinkTransaction.vue'),
        },
        {
          path: '/sub-gateway-report',
          name: 'SubGatewayReport',
          component: () => import('@/pages/Identifier/SubGatewayReport.vue'),
        },
        {
          path: '/internal-transfer',
          name: 'internalTransfer',
          component: () => import('@/pages/Services/InternalTransfer'),
        },
        {
          path: '/internal-transfer-acc',
          name: 'internalTransfer',
          component: () => import('@/pages/Services/InternalTransferAcc'),
        },
        {
          path: '/indirect_gateway_list',
          name: 'indirectGateWayList',
          component: () =>
            import('@/pages/IndirectGateway/IndirectGateWayList.vue'),
        },
        {
          path: '/indirect_gateway_details/:id',
          name: 'indirectGatewayDetails',
          component: () =>
            import('@/pages/IndirectGateway/IndirectGatewayDetails.vue'),
        },
        {
          path: '/deposit-statement',
          name: 'depositStatement',
          component: () => import('@/pages/Acc/DepositStatement.vue'),
        },
        {
          path: '/gateway-report-without-transaction',
          name: 'gatewayReportWithoutTransaction',
          component: () =>
            import('@/pages/Merchants/GatewayReportWithoutTransaction.vue'),
        },
        {
          path: '/reports',
          name: 'Reports',
          component: () => import('@/pages/Dashboard/ReportNew.vue'),
        },
        {
          path: '/refund-charge-available',
          name: 'chargeAvailableList',
          component: () => import('@/pages/Refund/ChargeAvailable'),
        },
        {
          path: '/deposit-list',
          name: 'depositList',
          component: () => import('@/pages/DepositWithId/DepositList.vue'),
        },
        {
          path: '/deposit-details/:id',
          name: 'depositDetails',
          component: () => import('@/pages/DepositWithId/DepositDetails.vue'),
        },
        {
          path: '/internal-transfers',
          name: 'InternalTransfers',
          component: () => import('@/pages/Acc/InternalTransfers.vue'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/pages/Auth/Auth'),
      children: [
        {
          name: 'login',
          path: '/login',
          component: () => import('@/pages/Auth/Login'),
        },
        // {
        //   name: "register",
        //   path: "/register",
        //   component: () => import("@/pages/Auth/Register")
        // }
      ],
    },
    {
      path: '*',
      redirect: '/dashboard',
      component: () => import('@/view/layout/Layout'),
    },
  ],
});
